import React from 'react';
//import { Link } from 'react-router-dom';

import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const OwlCarouselSliderHomeTestimonial = (props) => {	
	 const options = {
	 	 loop:true,
		margin:15,
		nav:false,
		dots: true,
		navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
		responsive:{
			0:{
				items:1
			},
			480:{
				items:1
			},			
			
			767:{
				items:1,
				margin:50
			},
			1000:{
				items:2
			}
		}
		
    };
  	
    return(
	<>
				
	<OwlCarousel className="owl-carousel home-carousel-1 m-b30" {...options}>	
	{props.data.map((item, index) => (
		<div className="item" key={index}>
			<div className="testimonial-5 bg-white radius-sm">
				<div className={`testimonial-pic-block ${props.radiusBx}`}> 
					<div className={`testimonial-pic ${props.radius}`}>
						
						<img src={require('../../assets/images/testimonials/'+item.src)} alt="" />
					</div>
				</div>
				<div className="testimonial-text clearfix">
					<div className="testimonial-paragraph">
						<span className="fa fa-quote-left site-text-primary"></span>
						<p>{item.description}</p>
					</div>
					<div className="testimonial-detail clearfix">
						<strong className="testimonial-name">{item.title}</strong>
						<span className="testimonial-position site-text-primary p-t10">{item.designation}</span>
					</div>
				</div>
			</div>
		</div>
		
	 ))}							  
	</OwlCarousel>
		
    </>
    )
}
OwlCarouselSliderHomeTestimonial.defaultProps = {
	radiusBx:"radius-bx",
	radius:"radius",
};
export default OwlCarouselSliderHomeTestimonial;